import { render, staticRenderFns } from "./ReportGroupTable.vue?vue&type=template&id=6ed926f8&scoped=true&"
import script from "./ReportGroupTable.vue?vue&type=script&lang=js&"
export * from "./ReportGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportGroupTable.vue?vue&type=style&index=0&id=6ed926f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed926f8",
  null
  
)

export default component.exports